<template>
  <v-container fluid fill-height grid-list-md>
    <v-layout row wrap justify-center>
      <v-flex xs12>
        <v-toolbar
          color="#eee"
          class="elevation-0 secondary--text hidden-print-only"
          style="background: transparent"
          tabs
        >
          <v-toolbar-title>Editar dados do Posto</v-toolbar-title>
        </v-toolbar>
      </v-flex>
      <v-flex xs11>
        <v-tabs class="hidden-print-only" v-model="tabs" grow>
          <v-tab class="font-weight-medium green--text text--darken-1">QRCode</v-tab>
          <v-tab class="font-weight-medium green--text text--darken-1">Imagens</v-tab>
          <v-tab class="font-weight-medium green--text text--darken-1">Informações</v-tab>
          <v-tab class="font-weight-medium green--text text--darken-1">Geo Localização</v-tab>
          <v-tab class="font-weight-medium green--text text--darken-1">Conveniência</v-tab>
          <v-tab class="font-weight-medium green--text text--darken-1">Horarios</v-tab>
          <v-tab class="font-weight-medium green--text text--darken-1">Automação</v-tab>
        </v-tabs>
        <v-card class="elevation-0">
          <v-tabs-items v-model="tabs">
            <v-tab-item lazy>
              <v-card-text class="pt-0">
                <v-container grid-list-md fluid v-if="posto">
                  <v-layout row wrap fill-height>
                    <v-flex xs12 class="text-xs-center">
                      <span class="headline secondary--text">QR Code {{posto.nome_fantasia}}</span>
                      <div>
                      <span class="headline secondary--text">CNPJ {{posto.cnpj}}</span>
                      </div>
                      <v-layout justify-center align-center fill-height>
                        <template>
                          <qrcode-vue ref="qrcode" renderAs="svg" :value="link" size="300" level="L"></qrcode-vue>
                        </template>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn flat block color="primary" @click="exportSVG()">
                  Baixar
                </v-btn>
              </v-card-actions>
            </v-tab-item>
            <v-tab-item lazy>
              <v-card-text class="pt-0">
                <v-container grid-list-md fluid>
                  <v-layout row wrap fill-height>
                    <v-flex xs6 class="text-xs-center">
                      <span class="headline secondary--text">Imagem de capa</span>
                      <v-layout justify-center align-center fill-height>
                        <v-slide-y-transition>
                          <v-flex xs11 v-show="croppingCapa">
                            <vue-croppie
                              ref="croppieCapaRef"
                              :enableExif="true"
                              :enforceBoundary="true"
                              :enableResize="false"
                              :enableOrientation="false"
                              :mouseWheelZoom="true"
                              :showZoomer="false"
                              :boundary="{ width: 600, height: 300 }"
                              :viewport="{ width: 400, height: 200}"
                            ></vue-croppie>
                            <v-btn
                              flat
                              @click="recortarCapa"
                              block
                              color="grey darken-2"
                            >Recortar imagem</v-btn>
                          </v-flex>
                        </v-slide-y-transition>
                        <v-slide-y-transition>
                          <v-flex xs10 v-show="!croppingCapa">
                            <v-img v-if="posto" :src="posto.url_imagem_posto" contains></v-img>
                          </v-flex>
                        </v-slide-y-transition>
                      </v-layout>
                    </v-flex>
                    <v-flex xs6 class="text-xs-center">
                      <span class="headline secondary--text">Imagem do logo</span>
                      <v-layout justify-center align-center fill-height>
                        <v-slide-y-transition>
                          <v-flex xs8 v-show="croppingLogo">
                            <vue-croppie
                              ref="croppieRef"
                              :enableExif="true"
                              :enforceBoundary="true"
                              :enableResize="false"
                              :enableOrientation="false"
                              :mouseWheelZoom="true"
                              :showZoomer="false"
                              :boundary="{ width: 400, height: 400 }"
                              :viewport="{ width: 200, height: 200, type : 'circle' }"
                            ></vue-croppie>
                            <v-btn
                              flat
                              @click="recortarLogo"
                              color="grey darken-2"
                              block
                            >Recortar imagem</v-btn>
                          </v-flex>
                        </v-slide-y-transition>
                        <v-slide-y-transition>
                          <v-flex xs5 v-show="!croppingLogo">
                            <v-img v-if="posto" :src="posto.url_logo" contains></v-img>
                          </v-flex>
                        </v-slide-y-transition>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn flat color="primary" @click="$refs.capaInput.click()" block>
                  Carregar imagem de capa
                  <input
                    type="file"
                    style="display:none"
                    accept="image/*"
                    ref="capaInput"
                    @input="carregarImagem"
                  />
                </v-btn>
                <v-btn flat color="primary" @click="$refs.logoInput.click()" block>
                  Carregar logo posto
                  <input
                    type="file"
                    style="display:none"
                    accept="image/*"
                    ref="logoInput"
                    @input="carregarLogo"
                  />
                </v-btn>
              </v-card-actions>
            </v-tab-item>
            <v-tab-item lazy>
              <v-card-text class="pt-0 pb-0">
                <v-container grid-list-lg fluid>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-layout row wrap justify-center>
                      <v-flex
                        xs12
                        class="headline secondary--text text-xs-center"
                      >Dados cadastrais do posto</v-flex>
                      <v-flex xs12 md4>
                        <v-text-field
                          label="Nome fantasia"
                          v-model="posto_model.nome_fantasia"
                          outline
                          required
                          :rules="[
                            (v) => !!v || 'O nome fantasia é obrigatório'
                          ]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4>
                        <v-text-field
                          label="Razão Social"
                          v-model="posto_model.razao_social"
                          outline
                          required
                          :rules="[
                            (v) => !!v || 'A razão social é obrigatória'
                          ]"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 md4>
                        <v-text-field
                          v-model="posto_model.email"
                          label="Email de notificações"
                          hint="Insira o email que receberá as notificações do posto"
                          outline
                        ></v-text-field>
                      </v-flex>

                      <v-flex
                        xs12
                        class="headline secondary--text text-xs-center pt-0"
                      >Endereço do posto</v-flex>

                      <v-flex xs6 md3 lg2>
                        <v-text-field
                          v-model="posto_model.endereco.cep"
                          maxlength="8"
                          label="CEP"
                          mask="#####-###"
                          required
                          :rules="[
                            (v) => !!v || 'O CEP é obrigatório'
                          ]"
                          outline
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 md5 lg4>
                        <v-text-field
                          v-model="posto_model.endereco.cidade"
                          label="Cidade"
                          required
                          outline
                          :rules="[
                            (v) => !!v || 'A cidade é obrigatória'
                          ]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md4>
                        <v-text-field
                          v-model="posto_model.endereco.logradouro"
                          label="Logradouro"
                          outline
                          required
                          :rules="[
                        (v) => !!v || 'O logradouro é obrigatório']"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 md2>
                        <v-text-field
                          v-model="posto_model.endereco.numero"
                          label="Nº"
                          mask="#########"
                          hint="Digite 0 para sem número"
                          outline
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 md3>
                        <v-text-field
                          v-model="posto_model.endereco.bairro"
                          label="Bairro"
                          outline
                          required
                          :rules="[
                            (v) => !!v || 'O bairro é obrigatório'
                          ]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs8 md5>
                        <v-text-field
                          v-model="posto_model.endereco.complemento"
                          label="Complemento"
                          counter="50"
                          maxlength="50"
                          outline
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4 md2>
                        <v-text-field
                          v-model="posto_model.endereco.estado"
                          label="UF"
                          outline
                          required
                          :rules="[
                            (v) => !!v || 'Insira uma UF válida'
                          ]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  flat
                  color="primary"
                  @click="atualizarPosto"
                  block
                  :loading="loading"
                >Salvar Informações</v-btn>
              </v-card-actions>
            </v-tab-item>
            <v-tab-item lazy>
              <edit-geo-position @info="showInfo"></edit-geo-position>
            </v-tab-item>
            <v-tab-item lazy>
              <v-card-text class="pt-0 pb-0">
                <v-container grid-list-md fluid>
                  <v-layout row wrap justify-center>
                    <v-flex
                      xs12
                      class="headline secondary--text text-xs-center"
                    >Selecione as conveniências do posto</v-flex>
                    <v-flex xs12>
                      <v-checkbox
                        color="primary"
                        v-model="posto_model.conveniencia"
                        :label="`Possui Conveniências`"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row justify-center>
                      <v-flex xs2>
                           <v-checkbox
                          color="primary"
                          v-model="posto_model.trocaDeOleo"
                          :label="`Troca de Óleo`"
                        ></v-checkbox>
                        </v-flex>
                        <v-flex xs2>
                          <v-checkbox
                          color="primary"
                          v-model="posto_model.oficina"
                          :label="`Oficina`"
                        ></v-checkbox>
                        </v-flex>
                        <v-flex xs2>
                          <v-checkbox
                          color="primary"
                          v-model="posto_model.restaurante"
                          :label="`Restaurante`"
                        ></v-checkbox>
                        </v-flex>
                        <v-flex xs2>
                          <v-checkbox
                          color="primary"
                          v-model="posto_model.banheiros"
                          :label="`Banheiros`"
                        ></v-checkbox>
                        </v-flex>
                        <v-flex xs2>
                          <v-checkbox
                          color="primary"
                          v-model="posto_model.loterica"
                          :label="`Loterica`"
                        ></v-checkbox>
                        </v-flex>
                        <v-flex xs2>
                          <v-checkbox
                          color="primary"
                          v-model="posto_model.pontoDescanso"
                          :label="`Ponto de descanso`"
                        ></v-checkbox>
                        </v-flex>
                    </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row justify-center>
                      <v-flex xs2>
                           <v-checkbox
                          color="primary"
                          v-model="posto_model.lavajato"
                          :label="`Lava-jato`"
                        ></v-checkbox>
                        </v-flex>
                        <v-flex xs2>
                           <v-checkbox
                          color="primary"
                          v-model="posto_model.borracharia"
                          :label="`Borracharia`"
                        ></v-checkbox>
                        </v-flex>
                        <v-flex xs2>
                          <v-checkbox
                          color="primary"
                          v-model="posto_model.hospedagem"
                          :label="`Hospedagem`"
                        ></v-checkbox>
                        </v-flex>
                        <v-flex xs2>
                          <v-checkbox
                          color="primary"
                          v-model="posto_model.farmacia"
                          :label="`Farmácia`"
                        ></v-checkbox>
                        </v-flex>
                        <v-flex xs2>
                          <v-checkbox
                          color="primary"
                          v-model="posto_model.patioCaminhoneiro"
                          :label="`Pátio Caminhoneiro`"
                        ></v-checkbox>
                        </v-flex>
                        <v-flex xs2>
                          <v-checkbox
                          color="primary"
                          v-model="posto_model.churrascaria"
                          :label="`Churrascaria`"
                        ></v-checkbox>
                        </v-flex>
                    </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  flat
                  color="primary"
                  block
                  @click="atualizarServicos"
                  :loading="loading"
                >SALVAR INFORMAÇÕES</v-btn>
              </v-card-actions>
            </v-tab-item>
            <v-tab-item lazy>
              <v-card-text class="pt-0 pb-0">
                <v-container grid-list-lg fluid>
                  <v-layout row wrap justify-center>
                    <v-flex
                      xs10
                      class="headline secondary--text text-xs-center"
                    >Horários de funcionamento do posto</v-flex>
                    <v-flex xs2 class="justify-center">
                    <v-btn outline round color='primary' @click="() => toogle24horas()">
                      <v-switch class="mt-3" v-model="posto_model.posto24horas">
                      <template v-slot:label>
                        Posto 24 horas
                      </template>
                    </v-switch>
                    </v-btn>
                  </v-flex>
                    <template v-for="dia in dias">
                      <v-flex xs6 sm6 md3 :key="dia.text">
                        <v-layout row wrap justify-start>
                          <v-flex xs12 class="font-weight-medium primary--text subheading">
                            {{dia.text}}
                            <v-spacer></v-spacer>
                            <span
                              class="font-weight-light green--text"
                              v-if="dia.cadastrado"
                            >Cadastrado</span>
                            <span class="font-weight-light red--text" v-else>Cadastro pendente</span>
                          </v-flex>
                          <v-flex xs5>
                            <v-text-field label="Entrada" mask="time" v-model="dia.hora_abertura"></v-text-field>
                          </v-flex>
                          <v-flex xs5>
                            <v-text-field label="Saída" mask="time" v-model="dia.hora_fechamento"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </template>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  flat
                  block
                  color="primary"
                  @click="cadastrarHorarios()"
                  :loading="loading"
                >SALVAR HORÁRIOS</v-btn>
              </v-card-actions>
            </v-tab-item>
            <v-tab-item>
              <v-card-text class="pt-0 pb-0">
                <v-container grid-list-lg fluid>
                  <v-layout row wrap justify-center>
                    <v-flex
                      xs12
                      class="headline secondary--text text-xs-center"
                    >Automação de Adquirente configurada</v-flex>
                    <v-flex xs12 md8>
                      <v-select
                        :items="automacoes_adquirente"
                        placeholder="Qual o seu sistema de retaguarda?"
                        :loading="loading"
                        @change="selecionarAutomacao(false)"
                        outline
                        single-line
                        v-model="retaguarda_adquirente"
                      >
                        <template v-slot:item="props">
                          <v-list-tile-avatar>
                            <v-avatar>
                              <v-icon color="success">android</v-icon>
                            </v-avatar>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title
                              v-text="props.item.nome"
                              class="font-weight-light black--text"
                            ></v-list-tile-title>
                            <v-list-tile-sub-title
                              v-text="props.item.descricao"
                              class="grey--text text--darken-3"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                        <template v-slot:selection="props">
                          <v-list-tile-avatar>
                            <v-avatar>
                              <v-icon color="success">android</v-icon>
                            </v-avatar>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title v-text="props.item.nome" class="font-weight-light"></v-list-tile-title>
                            <v-list-tile-sub-title
                              v-text="props.item.descricao"
                              class="grey--text text--darken-3"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </v-select>
                    </v-flex>
                    <v-flex
                      xs12
                      class="headline secondary--text text-xs-center"
                    >Automação de abastecimento configurada</v-flex>
                    <v-flex xs12 md8>
                      <v-select
                        :items="automacoes_abastecimento"
                        placeholder="Qual o seu sistema de retaguarda?"
                        :loading="loading"
                        @change="selecionarAutomacao(true)"
                        outline
                        single-line
                        v-model="retaguarda_abastecimento"
                      >
                        <template v-slot:item="props">
                          <v-list-tile-avatar>
                            <v-avatar>
                              <v-icon color="success">android</v-icon>
                            </v-avatar>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title
                              v-text="props.item.nome"
                              class="font-weight-light black--text"
                            ></v-list-tile-title>
                            <v-list-tile-sub-title
                              v-text="props.item.descricao"
                              class="grey--text text--darken-3"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                        <template v-slot:selection="props">
                          <v-list-tile-avatar>
                            <v-avatar>
                              <v-icon color="success">android</v-icon>
                            </v-avatar>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title v-text="props.item.nome" class="font-weight-light"></v-list-tile-title>
                            <v-list-tile-sub-title
                              v-text="props.item.descricao"
                              class="grey--text text--darken-3"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar :color="snackbar.color" :timeout="4000" :vertical="true" v-model="snackbar.active">
      {{snackbar.text}}
      <v-spacer></v-spacer>
      <v-btn @click="snackbar.active = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { postosDao } from '@/api'
import EditGeoPosition from '@/components/cadastros/EditGeoPosition'
import QrcodeVue from 'qrcode.vue'
import { saveAs } from 'file-saver'

window.EXIF = require('exif-js')

export default {
  components: { EditGeoPosition, QrcodeVue },
  data () {
    return {
      snackbar: {
        active: false,
        color: 'info',
        text: ''
      },
      retaguarda_adquirente: null,
      retaguarda_abastecimento: null,
      tabs: null,
      croppingCapa: false,
      croppingLogo: false,
      cropped: null,
      croppedCapa: null,
      valid: true,
      coordenadas: {
        latitude: null,
        longitude: null
      },
      PostoEndereco: null,
      domingoCadastrado: false,
      segundaCadastrado: false,
      tercaCadastrado: false,
      quartaCadastrado: false,
      quintaCadastrado: false,
      sextaCadastrado: false,
      sabadoCadastrado: false,
      automacoes_abastecimento: [],
      automacoes_adquirente: [],
      logo: {
        url_logo: '1'
      },
      imagem: {
        url_imagem: '1'
      },
      dias: [
        {
          dia_semana: 'domingo',
          hora_abertura: '',
          hora_fechamento: '',
          text: 'Domingo',
          cadastrado: false
        },
        {
          dia_semana: 'segunda',
          hora_abertura: '',
          hora_fechamento: '',
          text: 'Segunda',
          cadastrado: false
        },
        {
          dia_semana: 'terca',
          hora_abertura: '',
          hora_fechamento: '',
          text: 'Terça',
          cadastrado: false
        },
        {
          dia_semana: 'quarta',
          hora_abertura: '',
          hora_fechamento: '',
          text: 'Quarta',
          cadastrado: false
        },
        {
          dia_semana: 'quinta',
          hora_abertura: '',
          hora_fechamento: '',
          text: 'Quinta',
          cadastrado: false
        },
        {
          dia_semana: 'sexta',
          hora_abertura: '',
          hora_fechamento: '',
          text: 'Sexta',
          cadastrado: false
        },
        {
          dia_semana: 'sabado',
          hora_abertura: '',
          hora_fechamento: '',
          text: 'Sábado',
          cadastrado: false
        }
      ],
      cropper: false,
      croppersrc: null,
      dia: null,
      posto_model: {
        razao_social: null,
        nome_fantasia: null,
        email: null,
        endereco: {
          cep: null,
          logradouro: null,
          numero: null,
          bairro: null,
          cidade: null,
          estado: null
        },
        latitude: null,
        longitude: null,
        conveniencia: false,
        oficina: false,
        restaurante: false,
        trocaDeOleo: false,
        lavajato: false,
        hospedagem: false,
        banheiros: false,
        loterica: false,
        farmacia: false,
        patioCaminhoneiro: false,
        pontoDescanso: false,
        churrascaria: false,
        posto24horas: false
      }
    }
  },
  computed: {
    link () {
      return this.$store.getters.link
    },
    headers () {
      return this.$store.getters.headers
    },
    posto () {
      return this.$store.getters.posto
    },
    getImageData () {
      return this.imagem_logo
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    'posto_model.endereco.cep' (val) {
      if (val) {
        this.searchCep()
      }
    },
    automacoes_abastecimento (val) {
      if (this.posto_model.automacao_abastecimento && val.length) {
        let index = val.findIndex(aut => {
          return aut.id === this.posto_model.automacao_abastecimento
        })
        this.retaguarda_abastecimento = val[index]
      }
    },
    automacoes_adquirente (val) {
      if (this.posto_model.automacao_adquirente && val.length) {
        let index = val.findIndex(aut => {
          return aut.id === this.posto_model.automacao_adquirente
        })
        this.retaguarda_adquirente = val[index]
      }
    },
    posto (val) {
      if (val !== null && val !== undefined) {
        postosDao
          .getEndereco(this.posto.cnpj, this.headers)
          .then(response => {
            return response.json()
          })
          .then(result => {
            this.PostoEndereco = result
            this.montarDados()
            this.buscarHorarioFuncionamento()
          })
        this.carregarAutomacoes(true)
        this.carregarAutomacoes(false)
      }
    }
  },
  mounted () {
    if (this.posto) {
      this.carregarAutomacoes(true)
      this.carregarAutomacoes(false)
      if (!this.PostoEndereco) {
        postosDao
          .getEndereco(this.posto.cnpj, this.headers)
          .then(response => {
            return response.json()
          })
          .then(result => {
            this.PostoEndereco = result
            this.montarDados()
            this.buscarHorarioFuncionamento()
          })
      }
    }
  },
  methods: {
    toogle24horas () {
      this.$store
        .dispatch('toogle24horas')
    },
    exportSVG () {
      var svg = this.$refs.qrcode.$el
      // first create a clone of our svg node so we don't mess the original one
      var clone = svg.cloneNode(true)
      // parse the styles
      this.parseStyles(clone)

      // create a doctype
      var svgDocType = document.implementation.createDocumentType('svg', '-//W3C//DTD SVG 1.1//EN', 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd')
      // a fresh svg document
      var svgDoc = document.implementation.createDocument('http://www.w3.org/2000/svg', 'svg', svgDocType)
      // replace the documentElement with our clone
      svgDoc.replaceChild(clone, svgDoc.documentElement)
      // get the data
      var svgData = (new XMLSerializer()).serializeToString(svgDoc)

      // now you've got your svg data, the following will depend on how you want to download it
      // e.g yo could make a Blob of it for FileSaver.js
      /*
      var blob = new Blob([svgData.replace(/></g, '>\n\r<')])
      saveAs(blob, 'myAwesomeSVG.svg')
      */
      // here I'll just make a simple a with download attribute

      var blob = new Blob([svgData.replace(/></g, '>\n\r<')])
      saveAs(blob, `qrcode-${this.posto.nome_fantasia}.svg`)

      // var a = document.createElement('a')
      // a.href = 'data:image/svg+xml; charset=utf8, ' + encodeURIComponent(svgData.replace(/></g, '>\n\r<'))
      // a.download = 'myAwesomeSVG.svg'
      // a.innerHTML = 'download the svg file'
      // document.body.appendChild(a)
    },
    parseStyles (svg) {
      var styleSheets = []
      var i
      // get the stylesheets of the document (ownerDocument in case svg is in <iframe> or <object>)
      var docStyles = svg.ownerDocument.styleSheets

      // transform the live StyleSheetList to an array to avoid endless loop
      for (i = 0; i < docStyles.length; i++) {
        styleSheets.push(docStyles[i])
      }

      if (!styleSheets.length) {
        return
      }

      var defs = svg.querySelector('defs') || document.createElementNS('http://www.w3.org/2000/svg', 'defs')
      if (!defs.parentNode) {
        svg.insertBefore(defs, svg.firstElementChild)
      }
      svg.matches = svg.matches || svg.webkitMatchesSelector || svg.mozMatchesSelector || svg.msMatchesSelector || svg.oMatchesSelector

      // iterate through all document's stylesheets
      for (i = 0; i < styleSheets.length; i++) {
        var currentStyle = styleSheets[i]

        var rules
        try {
          rules = currentStyle.cssRules
        } catch (e) {
          continue
        }
        // create a new style element
        var style = document.createElement('style')
        // some stylesheets can't be accessed and will throw a security error
        var l = rules && rules.length
        // iterate through each cssRules of this stylesheet
        for (var j = 0; j < l; j++) {
          // get the selector of this cssRules
          var selector = rules[j].selectorText
          // probably an external stylesheet we can't access
          if (!selector) {
            continue
          }

          // is it our svg node or one of its children ?
          if ((svg.matches && svg.matches(selector)) || svg.querySelector(selector)) {
            var cssText = rules[j].cssText
            // append it to our <style> node
            style.innerHTML += cssText + '\n'
          }
        }
        // if we got some rules
        if (style.innerHTML) {
          // append the style node to the clone's defs
          defs.appendChild(style)
        }
      }
    },
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError (error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    },
    montarDados () {
      this.posto_model = { ...this.PostoEndereco }
      this.posto_model.endereco = { ...this.PostoEndereco.endereco }
      if (this.posto_model.automacao_adquirente && this.automacoes_adquirente.length) {
        let index = this.automacoes_adquirente.findIndex(aut => {
          return aut.id === this.posto_model.automacao_adquirente
        })
        this.retaguarda_adquirente = this.automacoes_adquirente[index]
      }
      if (this.posto_model.automacao_abastecimento && this.automacoes_abastecimento.length) {
        let index = this.automacoes_abastecimento.findIndex(aut => {
          return aut.id === this.posto_model.automacao_abastecimento
        })
        this.retaguarda_abastecimento = this.automacoes_abastecimento[index]
      }
    },
    selecionarAutomacao (paraAbastecimento) {
      if (!this.posto.ativo) {
        alert('Esse posto está desativado no sistema')
        return
      }
      this.$store
        .dispatch('selecionarAutomacao', {
          automacao: paraAbastecimento ? this.retaguarda_abastecimento.id : this.retaguarda_adquirente.id
        })
        .then(() => {
          postosDao
            .getEndereco(this.posto.cnpj, this.headers)
            .then(response => {
              return response.json()
            })
            .then(result => {
              this.PostoEndereco = result
              this.montarDados()
              this.buscarHorarioFuncionamento()
            })
          this.showInfo('Sistema de retaguarda selecionado com sucesso')
        })
        .catch(error => {
          this.showError(error)
        })
    },
    recortarLogo () {
      let options = {
        type: 'base64',
        format: 'png',
        circle: true
      }
      this.$refs.croppieRef.result(options, output => {
        this.cropped = output
        this.croppingLogo = false
        this.$store.dispatch('atualizarLogo', {
          cnpj: this.posto.cnpj,
          imagem: this.cropped
        })
      })
    },
    recortarCapa () {
      let options = {
        type: 'base64',
        format: 'png'
      }
      this.$refs.croppieCapaRef.result(options, output => {
        this.croppedCapa = output
        this.croppingCapa = false
        this.$store.dispatch('atualizarImagemPosto', {
          cnpj: this.posto.cnpj,
          imagem: this.croppedCapa
        })
      })
    },
    carregarLogo (event) {
      if (event.target.files && event.target.files[0]) {
        let imagem = event.target.files[0]
        let reader = new FileReader()
        reader.onloadend = e => {
          this.croppingLogo = true
          this.$refs.croppieRef.bind({
            url: reader.result
          })
          this.$nextTick(() => {
            this.$refs.croppieRef.setZoom(0.1)
          })
        }
        reader.readAsDataURL(imagem)
      }
    },
    carregarImagem (event) {
      if (event.target.files && event.target.files[0]) {
        let imagem = event.target.files[0]
        let reader = new FileReader()
        reader.onloadend = e => {
          this.croppingCapa = true
          this.$refs.croppieCapaRef.bind({
            url: reader.result
          })
          this.$nextTick(() => {
            this.$refs.croppieCapaRef.setZoom(0.1)
          })
        }
        reader.readAsDataURL(imagem)
      }
    },
    cadastrarHorarios () {
      var erro = false
      this.dias.forEach(dia => {
        if (dia.hora_abertura.length === 4) {
          dia.hora_abertura = [
            dia.hora_abertura.slice(0, 2),
            dia.hora_abertura.slice(2, 4)
          ].join(':')
        } else if (dia.hora_abertura.length > 4) {
          dia.hora_abertura = [
            dia.hora_abertura.split(':')[0],
            dia.hora_abertura.split(':')[1]
          ].join(':')
        }

        if (dia.hora_fechamento.length === 4) {
          dia.hora_fechamento = [
            dia.hora_fechamento.slice(0, 2),
            dia.hora_fechamento.slice(2, 4)
          ].join(':')
        } else if (dia.hora_fechamento.length > 4) {
          dia.hora_fechamento = [
            dia.hora_fechamento.split(':')[0],
            dia.hora_fechamento.split(':')[1]
          ].join(':')
        }

        if ((dia.hora_fechamento === '' && dia.hora_abertura !== '') || (dia.hora_fechamento !== '' && dia.hora_abertura === '')) {
          erro = true
        }

        if ((dia.hora_fechamento === '' && dia.hora_abertura === '' && dia.cadastrado) || (dia.hora_fechamento !== '' && dia.hora_abertura !== '')) {
          this.$store.dispatch('inserirHorarioFuncionamento', dia).then(() => {
            if (dia.hora_fechamento === '' && dia.hora_abertura === '') {
              dia.cadastrado = false
            } else {
              dia.cadastrado = true
            }
            this.$forceUpdate()
          }).catch(() => {
            erro = true
          })
        }
      })

      if (erro) {
        this.showError('Desculpe, não foi possível atualizar os dados')
      } else {
        this.showInfo('Horário de funcionamento atualizado com sucesso')
      }
    },
    searchCep () {
      fetch(`https://viacep.com.br/ws/${this.posto_model.endereco.cep}/json/`, {
        method: 'get',
        mode: 'cors',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(res => res.json())
        .then(json => {
          this.posto_model.endereco.logradouro = json.logradouro
          this.posto_model.endereco.bairro = json.bairro
          this.posto_model.endereco.cidade = json.localidade
          this.posto_model.endereco.estado = json.uf
        })
    },
    atualizarPosto () {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('atualizarPosto', { posto: this.posto_model })
          .then(() => {
            this.showInfo('Informações atualizadas com sucesso')
          })
          .catch(() => {
            this.showError('Desculpe, não foi possível atualizar os dados')
          })
      }
    },
    atualizarServicos () {
      if (!this.posto.ativo) {
        alert('Esse posto está desativado no sistema')
        return
      }
      postosDao
        .confirmarServicos(this.posto.cnpj, this.posto_model, this.headers)
        .then(response => {
          if (response.status === 200) {
            console.log('ok')
          }
          this.showInfo('Conviniências atualizadas com sucesso')
        })
        .catch(() => {
          this.showError(
            'Desculpe, não foi possível atualizar as conviniências'
          )
        })
    },
    async abrirGeoCordenadas () {
      this.geoPositionQuestion = false
      this.$emit('atualizarGeoPosition')
      try {
        await this.buscarCoordenadas()
      } catch {
        this.showError(
          'Desculpe, mas não conseguimos encontrar as coordenadas georaficas do sua posto! Verifique se o endereço informado está correto e tente novamente.'
        )
      }
      this.$store.dispatch('cadastroPostoByClient', {
        posto: this.posto_model
      })
    },
    buscarHorarioFuncionamento () {
      postosDao
        .getHorarioFuncionamento(this.posto.cnpj, this.headers)
        .then(response => {
          return response.json()
        })
        .then(result => {
          for (var i = 0; i < result.length; i++) {
            let index = this.dias.findIndex(dia => {
              return dia.dia_semana === result[i].dia_semana
            })
            if (index !== -1) {
              this.dias[index] = {
                ...result[i],
                text: this.dias[index].text,
                cadastrado: true
              }
            }
          }
        })
    },
    buscarCoordenadas () {
      return this.$store.dispatch('pegarCoordenadas', {
        logradouro: this.posto_model.logradouro,
        numero: this.posto_model.numero,
        bairro: this.posto_model.bairro,
        cidade: this.posto_model.cidade,
        estado: this.posto_model.estado
      })
        .then(json => {
          this.coordenadas.latitude = json.latitude
          this.coordenadas.longitude = json.longitude
        })
    },
    carregarAutomacoes (eAbastecimento) {
      this.$store.dispatch('carregarAutomacoes', eAbastecimento).then(json => {
        if (eAbastecimento) this.automacoes_abastecimento = json
        else this.automacoes_adquirente = json
      })
    }
  }
}
</script>
